import React, { useState, useEffect } from 'react';
import { Modal, Carousel, Button } from 'react-bootstrap';

const ImageViewerModal = ({ show, onHide, images, initialIndex = 0 }) => {
    const [index, setIndex] = useState(initialIndex);

    useEffect(() => {
        setIndex(initialIndex);
    }, [initialIndex, show]);

    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);
    };

    if (!images || images.length === 0) return null;

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            size="lg"
            contentClassName="bg-transparent border-0"
            dialogClassName="modal-90w"
        >
            <Modal.Body className="p-0 position-relative d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
                <Button
                    variant="light"
                    className="position-absolute top-0 end-0 m-3 rounded-circle btn-icon-circle"
                    onClick={onHide}
                    style={{ zIndex: 1050, opacity: 0.8 }}
                >
                    <i className="bi bi-x-lg"></i>
                </Button>

                <Carousel
                    activeIndex={index}
                    onSelect={handleSelect}
                    interval={null}
                    indicators={images.length > 1}
                    controls={images.length > 1}
                    className="w-100 h-100"
                >
                    {images.map((url, idx) => (
                        <Carousel.Item key={idx} className="h-100 text-center">
                            <img
                                className="d-block w-100"
                                src={url}
                                alt={`Slide ${idx}`}
                                style={{ maxHeight: '80vh', objectFit: 'contain' }}
                            />
                            <Carousel.Caption className="pb-1" style={{ textShadow: '1px 1px 2px rgba(0,0,0,0.8)' }}>
                                <p>{idx + 1} / {images.length}</p>
                            </Carousel.Caption>
                        </Carousel.Item>
                    ))}
                </Carousel>
            </Modal.Body>
        </Modal>
    );
};

export default ImageViewerModal;
